import {
  RawDraftContentState,
  RawDraftContentBlock,
  RawDraftInlineStyleRange,
} from "draft-js"
import { Block, InlineStyleRanges } from "../../../rpcs/dist/EpisodeRPC"
import { inlineStyleNum } from "../chat-style/inline-style"

export const convertToOBlocksFromRawState = (
  rawDraftContentState: RawDraftContentState,
): Block[] => {
  return convertToOBlocks(rawDraftContentState.blocks)
}

function convertToOBlocks(blocks: RawDraftContentBlock[]): Block[] {
  return blocks.map(b => {
    return {
      key: b.key,
      text: b.text,
      inlineStyleRanges: convertInlineStyleRanges(b.inlineStyleRanges),
    }
  })
}

function convertInlineStyleRanges(
  inlineStyleRanges: RawDraftInlineStyleRange[],
): InlineStyleRanges[] {
  return inlineStyleRanges.map(
    (style: RawDraftInlineStyleRange & { style: string[] }) => {
      return {
        length: style.length,
        offset: style.offset,
        style: inlineStyleNum(style.style),
      }
    },
  ) as InlineStyleRanges[]
}
